import { CandlestickPatternKind } from '../util/IndicatorUtils/patterns/chartPatternTypes'

/** Official TradingView candlestick pattern indicator titles ({Name} - Bullish/Bearish) */
export const TRADINGVIEW_CANDLESTICK_PATTERN_NAMES: Record<CandlestickPatternKind, string> = {
    BULLISH_ENGULFING: 'Engulfing - Bullish',
    HAMMER: 'Hammer - Bullish',
    MORNING_STAR: 'Morning Star - Bullish',
    PIERCING_LINE: 'Piercing Line - Bullish',
    BULLISH_HARAMI: 'Harami - Bullish',
    THREE_WHITE_SOLDIERS: 'Three White Soldiers - Bullish',
    INVERTED_HAMMER: 'Inverted Hammer - Bullish',
    DRAGONFLY_DOJI: 'Dragonfly Doji - Bullish',
    BULLISH_ABANDONED_BABY: 'Abandoned Baby - Bullish',
    THREE_INSIDE_UP: 'Three Inside Up - Bullish',
    THREE_OUTSIDE_UP: 'Three Outside Up - Bullish',
    BULLISH_KICKER: 'Kicking - Bullish',
    TWEEZER_BOTTOM: 'Tweezer Bottom - Bullish',
    RISING_THREE_METHODS: 'Rising Three Methods - Bullish',
    CONCEALING_BABY_SWALLOW: 'Concealing Baby Swallow - Bullish',
    MAT_HOLD: 'Mat Hold - Bullish',
    BULLISH_SEPARATING_LINES: 'Separating Lines - Bullish',
    BULLISH_BELT_HOLD: 'Belt Hold - Bullish',
    THREE_LINE_STRIKE_BULLISH: 'Three-Line Strike - Bullish',
    LADDER_BOTTOM: 'Ladder Bottom - Bullish',
    MEETING_LINES: 'Meeting Lines - Bullish',
    BEARISH_ENGULFING: 'Engulfing - Bearish',
    BEARISH_BELT_HOLD: 'Belt Hold - Bearish',
    THREE_BLACK_CROWS: 'Three Black Crows - Bearish',
    THREE_LINE_STRIKE_BEARISH: 'Three-Line Strike - Bearish',
    HANGING_MAN: 'Hanging Man - Bearish',
    UPSIDE_GAP_TWO_CROWS: 'Upside Gap Two Crows - Bearish',
    EVENING_STAR: 'Evening Star - Bearish',
    SHOOTING_STAR: 'Shooting Star - Bearish',
    BEARISH_HARAMI: 'Harami - Bearish',
    BEARISH_DOJI_STAR: 'Doji Star - Bearish',
    BEARISH_ABANDONED_BABY: 'Abandoned Baby - Bearish',
    TWEEZER_TOP: 'Tweezer Top - Bearish',
    BEARISH_KICKER: 'Kicking - Bearish',
    THREE_INSIDE_DOWN: 'Three Inside Down - Bearish',
    THREE_OUTSIDE_DOWN: 'Three Outside Down - Bearish',
    BEARISH_MAT_HOLD: 'Mat Hold - Bearish',
    DARK_CLOUD_COVER: 'Dark Cloud Cover - Bearish',
}

export const getTradingViewCandlestickPatternName = (kind: CandlestickPatternKind): string =>
    TRADINGVIEW_CANDLESTICK_PATTERN_NAMES[kind]
